var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full_layout information", attrs: { id: "Information" } },
    [
      _c("h3", { staticClass: "informationTitle" }, [
        _vm._v(_vm._s(_vm.$t("AboutUs")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "informationDetail" },
        [
          _c("img", {
            attrs: { src: require("../../../static/images/image45.jpg") }
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("el-image", {
            staticClass: "businessLicense",
            attrs: {
              src: "../../../static/images/businessLicense.jpg",
              "preview-src-list": ["../../../static/images/businessLicense.jpg"]
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "informationDetailList" }, [
      _c("h2", [_vm._v("DAKA达咖文化")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "达咖文化，又名DAKA，成立于2015年，是国内球星卡发行商，多年来一直专注于中国体育、娱乐、艺术、科学、历史等文化收藏产品创作和发行。目前为止，DAKA已为众多IP打造了数十款人气产品，例如曼城等国际顶级俱乐部、CBA等职业联赛、上海申花等中超俱乐部、《我和我的祖国》等影视作品、爱奇艺偶像练习生等娱乐综艺、以及中国拳王邹市明等收藏卡相关产品。 秉承着“收藏因为热爱”的理念，DAKA仍将继续深耕竞技体育收藏卡，创造更多受收藏迷喜爱的新产品，并积极开拓电竞、日韩娱乐、动漫等更多产品领域，更好的服务中国收藏玩家。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "informationDetailList" }, [
      _c("h2", [_vm._v("什么是球星卡？")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "交换收藏卡是一张卡片，通常由一张薄的或者厚的纸板做成，包含一个特定人物、地点、真实或虚拟物品，以及一段文字(评论、数据、轶事)来对图片做出简短的介绍。市面存在众多不同品种的卡片，卡片上通常镶嵌比赛中用过的球衣、球员签字甚至是人物的毛发等物料。 球星卡通常随机插放于卡包，再装入盒装，最后放置于箱内由有版权的球星卡公司发行。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d70a5bd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d70a5bd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/information/about.vue
// module id = null
// module chunks = 